export default {
    permissionLoading: false,
    permissionsListLoading: false,
    permissionsList: [],
}